function hasOwnOrProtoProp(obj, key) {
    let cur = obj;
    while (cur && cur !== Object.prototype) {
        if (Object.prototype.hasOwnProperty.call(cur, key)) {
            return true;
        }
        cur = Object.getPrototypeOf(cur);
    }
    return false;
}
export default class BaseEntity {
    parseProperty(data, name) {
        if (hasOwnOrProtoProp(data, name)) {
            return data[name];
        }
        throw new Error(`Attribute '${name}' is not present in data. Try one of [${Object.keys(data).join(', ')}]`);
    }
}
